import React from 'react';
import { Alert } from '@cowbell/ui/core';
import UnderwriterCoverageListing from './UnderwriterCoverageListing';
import UnderwriterRatingOptions from '../modifiers/UnderwriterRatingOptions';
import { SchemaMapProvider } from '../../inputs-factory/SchemaMapContext';
import { useGetCoveragePayloadSchemas } from '../../../../hooks/useGetCoveragePayloadSchemas';
import type { RaterXPreset } from '../../../../api/types/rater-x-preset';

interface ExcessUnderwriterCoveragesProps {
  readonly raterX: RaterXPreset | null | undefined;
  readonly productKey: string;
}

// Excess-only coverage listing: fetches the amendatory schema map (decoupled,
// non-blocking) and provides it to the schema-gated edit affordances. On a fetch
// failure a non-blocking notice renders and the page still loads with all
// coverages; an empty map is silent (legitimately no input-bearing endorsements).
export default function ExcessUnderwriterCoverages({
  raterX,
  productKey,
}: ExcessUnderwriterCoveragesProps) {
  const { schemas, isError } = useGetCoveragePayloadSchemas(
    productKey,
    raterX?.productVersion
  );

  return (
    <SchemaMapProvider schemas={schemas}>
      {isError && (
        <Alert
          color="yellow"
          variant="light"
          title="Endorsement inputs unavailable"
          mb="sm"
        >
          Couldn&apos;t load amendatory endorsement inputs. You can still review and
          adjust all coverages; refresh to edit endorsement details.
        </Alert>
      )}
      <UnderwriterCoverageListing categories={raterX?.coverageCategories} />
      <UnderwriterRatingOptions rateModifiers={raterX?.rateModifierCategories} />
    </SchemaMapProvider>
  );
}
